import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class ReportProfileApi extends BaseApi {
    constructor(client) { super(client, '/report-profiles'); }

    async getIndex() {
        try {
            return (await this.client.get(`${this.basePath}/index`)).data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async setDefault(id, expectedVersion) {
        try {
            return (await this.client.put(`${this.basePath}/${id}/default`, { expectedVersion })).data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async delete(id, expectedVersion) {
        try {
            return (await this.client.delete(`${this.basePath}/${id}`, {
                params: { expectedVersion },
            })).data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
